/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:none}.BackdropActive[_nghost-%COMP%]{bottom:0;left:0;position:absolute;right:0;top:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(25,32,45,.7);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:1040}.ModalContainer[_ngcontent-%COMP%]{background:#fff;border-radius:3px;-webkit-box-shadow:0 0 4px 0 rgba(0,0,0,.08),0 2px 4px 0 rgba(0,0,0,.12);box-shadow:0 0 4px 0 rgba(0,0,0,.08),0 2px 4px 0 rgba(0,0,0,.12);z-index:1090}.ModalContainer.SmallSize[_ngcontent-%COMP%]{max-width:600px;min-width:400px}.ModalContainer.LargeSize[_ngcontent-%COMP%]{max-width:1000px;min-width:800px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/@shared/ui/modal/modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js